import { defineMessages } from 'react-intl'

const trainingPlanMessages = defineMessages({
  week: {
    id: 'trainingPlans.week',
    defaultMessage: '{count} {count, plural, one {Week} other {Weeks}}',
    description: 'The weeks.'
  },
  workout: {
    id: 'workout',
    defaultMessage: '{count} {count, plural, one {Workout} other {Workouts}}',
    description: 'The workouts.'
  }
})
export default trainingPlanMessages
